import { Stats } from '../components/Stats/Stats';

export function ProfilePage() {
  return <Stats />;
}
